export const TOPBAR_HEIGHT = 46
export const BOTTOMBAR_HEIGHT = 64

export const POPUP_DIMENSIONS = {
  width: 360,
  height: 600,
}
